import { z } from "zod";
/**
 * The error envelope, and the client's half of D27.
 *
 * The server never sends prose a user will read. It sends a stable
 * `messageKey` plus optional `params`, and the app renders the sentence in
 * whichever locale it is running. That is what lets the same backend serve an
 * English and a Portuguese client without knowing either exists.
 *
 * `code` is here too, but for a different consumer: it is coarse and
 * protocol-shaped, and client code branches on it (retry? re-authenticate?
 * give up?) rather than on the message key, which is far more numerous and
 * exists to be displayed rather than switched on.
 *
 * `requestId` is echoed so a user can quote one number and have it found in
 * the logs.
 */
export const errorEnvelope = z.object({
    error: z.object({
        /** Coarse and protocol-shaped: CONFLICT, NOT_FOUND, RATE_LIMITED. */
        code: z.string().min(1),
        /**
         * i18n key, `<domain>.<condition>`. Stable forever once shipped: an old
         * build still reports the old key, and a renamed key degrades to
         * untranslated text rather than to an error.
         */
        messageKey: z.string().min(1),
        /** Interpolation values for the translated sentence, when it needs any. */
        params: z.record(z.string(), z.union([z.string(), z.number()])).optional(),
        /** Correlates a user's report with a log line. */
        requestId: z.string().optional(),
    }),
});
//# sourceMappingURL=error.js.map